import React, { FunctionComponent } from 'react'
import { Link } from '../Link'
import styles from './style.module.scss'
import { isCallable } from '@afterpay/utils'

interface ToastLinkProps {
  label?: string
  linkTarget?: string
  action?: string | (() => void)
  testNameSpace?: string
}

const ToastLink: FunctionComponent<ToastLinkProps> = ({ label, action, testNameSpace = '', linkTarget }) => {
  const isLinkURL: boolean = typeof action === 'string' && action.length > 0
  const isLinkButton: boolean = isCallable(action)

  if (!isLinkURL && !isLinkButton) {
    return null
  }

  if (isLinkURL) {
    return (
      <div className={styles.toastLinkURL}>
        <Link kind={'Underline'} href={action as string} target={linkTarget} testNameSpace={testNameSpace}>
          {label}
        </Link>
      </div>
    )
  }

  if (isLinkButton) {
    return (
      <button
        className={styles.toastLinkButton}
        onClick={action as () => void}
        {...(testNameSpace.length > 0 && { 'data-testid': `${testNameSpace}-link-btn` })}
      >
        {label}
      </button>
    )
  }
}

export default ToastLink
